import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { CenterSpinner } from "@vendor-app/app/AdminRoute/components/elements/CenterSpinner";

import { useSmartrrVendorSelector, useSmartrrVendorDispatch } from "@vendor-app/app/_state/typedVendorReduxHooks";
import { syncAccountPlans } from "@vendor-app/app/_state/actionCreators/accountPlans";
import { useSmartrrFlags } from "@smartrr/shared/LaunchDarkly";
import { useIsAccountSetupCompletedSelector } from "@vendor-app/app/_state/reducers/organizations";

export const Route = createFileRoute("/admin/")({
  component: Index,
});

function Index() {
  const { activePlan } = useSmartrrVendorSelector(state => state.accountPlans);
  const {
    displayHomePage: displayHomePageFeatureFlag,
    vendorPortalGettingStartedPage: gettingStartedFeatureFlagEnabled,
  } = useSmartrrFlags();
  const dispatch = useSmartrrVendorDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const isAccountSetupCompleted = useIsAccountSetupCompletedSelector();

  useEffect(() => {
    const fetchAccountPlans = async () => {
      try {
        if (!activePlan) {
          await dispatch(syncAccountPlans());
        }
      } catch (error) {
        console.error("Failed to sync account plans:", error);
      } finally {
        setIsLoading(false);
      }
    };
    void fetchAccountPlans();
  }, [activePlan]);

  if (isLoading || displayHomePageFeatureFlag === undefined || gettingStartedFeatureFlagEnabled === undefined) {
    return <CenterSpinner />;
  }

  if (!activePlan) {
    return <Navigate to="/admin/smartrr-account" />;
  }

  if (!gettingStartedFeatureFlagEnabled && !isAccountSetupCompleted) {
    return <Navigate to="/admin/setup" />;
  }

  if (gettingStartedFeatureFlagEnabled && !isAccountSetupCompleted) {
    return <Navigate to="/admin/getting-started" />;
  }

  if (displayHomePageFeatureFlag) {
    return <Navigate to="/admin/home" />;
  }

  return <Navigate to="/admin/subscriptions" />;
}
